import { mapState } from 'vuex'
import { PRODUCTS_CODES, PRODUCTS_CODES_VALUE } from '@/common/const/operators.const'

export default {
  computed: {
    ...mapState({
      product: state => state.voucher.data.product,
      isLoading: state => state.voucher.loading,
      formData: state => state.voucher.data
    }),
    products: function () {
      return this.getProducts()
    },
    productValues: function () {
      return this.getProductValues(this.product)
    },
    productName: function () {
      return this.productValues.find(item => item.value === this.formData.amount).name
    }
  },
  methods: {
    getProducts () {
      return PRODUCTS_CODES
    },
    getProductValues (product) {
      return PRODUCTS_CODES_VALUE[product]
    },
    isProductActive (value) {
      return this.product === value
    },
    getProductTime (amount) {
      const item = this.productValues.find(item => item.value === amount)
      if (item) {
        return item.time
      }
      return null
    },
    getProductOrigValue (amount) {
      const item = this.productValues.find(item => item.value === amount)
      if (item) {
        return item.origValue
      }
      return null
    }
  }
}
